export default __webpack_public_path__ + "static/media/Hewlett Packard.d9eb46fb.svg";